import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MaterialTable from '@material-table/core';
import { useHistory } from 'react-router-dom';


function WorkPage() {
  let history = useHistory();
  let { id } = useParams();

  const [data, setData] = useState({title: "", publications: [], dating: []});

  useEffect(() => {
      fetch("http://medpub-backend-dmpn.ext.ocp-prod-0.k8s.it.helsinki.fi/work/" + id)
      .then(res => res.json())
      .then(result => setData(result))
      .catch(console.log);
  }, [id]);

  return (
    <div className="home">
      <div class="entity-page-container">
        <div class="page-header">
          <img src="register-works.png" alt="" />
          <h1>{data.title}</h1>
        </div>
        <div class="row entity-page-content justify-content-start">
          <div class="col-lg-2">
            <p>
              Work ID: {id}
            </p>
            <p>
              Status: {data.status}
            </p>
            <p>
              Authorial status: {data.authorial_status}
            </p>
            <p>
              Existence and editions: {data.editions_and_preservation}
            </p>
            <p>
              Notes: {data.additional_info}
            </p>
          </div>
          <div class="col-lg-10">
            <p>
              <h4>Persons connected:</h4>
            </p>
            <p>
              <MaterialTable
                columns={[
                  { title: "ID", field: "id" },
                  { title: "Release no.", field: "num_publ"},
                  { title: "Name", field: "person_name" },
                  { title: "Station", field: "in_occ" },
                  { title: "Role", field: "role_name" }
                ]}
                data={data.publications}
                options={{
                  toolbar: false,
                  header: true,
                  columnsButton: false,
                  paging: false,
                  headerStyle: {
                    backgroundColor: '#1b437e',
                    color: '#FFF'
                  },
                }}
                onRowClick={((evt, selectedRow) => {
                  history.push('/person/' + selectedRow.id)
                })}
              />
            </p>
            <p>
              <h4>Dating:</h4>
            </p>
            <p>
              <MaterialTable
                columns={[
                  { title: "Release no.", field: "pub_no" },
                  { title: "Start date", field: "start_date"},
                  { title: "End date", field: "end_date" },
                  { title: "Certainty", field: "certainty" },
                  { title: "Information Source", field: "source"}
                ]}
                data={data.dating}
                options={{
                  toolbar: false,
                  header: true,
                  columnsButton: false,
                  paging: false,
                  headerStyle: {
                    backgroundColor: '#1b437e',
                    color: '#FFF'
                  },
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkPage;